import { Outlet, useLocation } from 'react-router-dom';
import AppHeader from './AppHeader';
import ConsultationInquiryModal from './features/ConsultationInquiryModal';
import Footer from './feature/Footer';

const MINIMAL_HEADER_PATHS: RegExp[] = [
  /^\/yangbok-v5\/test\/photos/,
  /^\/yangbok-v5\/test\/reviews/,
  /^\/yangbok-v5\/test\/lookbook/,
];

export default function AppLayout() {
  const location = useLocation();
  const minimal = MINIMAL_HEADER_PATHS.some((pattern) =>
    pattern.test(location.pathname),
  );

  return (
    <div className="min-h-[100dvh] bg-[#F7F2EA]">
      <AppHeader minimal={minimal} />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ConsultationInquiryModal />
    </div>
  );
}
